// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Dt4w","col":"styles_col__3ShTQ"};